import {number, string} from "yup";
import i18n from 'i18next';

export const onlyStringSchema = string().required(i18n.t('reqText')).matches(/^([^0-9]*)$/gm, i18n.t('onlyString')).typeError(i18n.t('onlyString'))

export const stringReqSchema = string().required(i18n.t('reqText')).typeError(i18n.t('reqText'))

export const numberMin0Schema = number().required(i18n.t('reqText')).typeError(i18n.t('mustHaveNumber')).min(0, i18n.t('minNumber0'))
export const numberMin1Schema = number().required(i18n.t('reqText')).typeError(i18n.t('mustHaveNumber')).min(1, i18n.t('minNumber1'))
export const numberSchema = number().required(i18n.t('reqText')).typeError(i18n.t('mustHaveNumber'))
